
    const data = {"name":"src/core/icons/city","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M19 15h-2v-2h2m0 6h-2v-2h2M13 7h-2V5h2m0 6h-2V9h2m0 6h-2v-2h2m0 6h-2v-2h2m-6-6H5V9h2m0 6H5v-2h2m0 6H5v-2h2m8-6V5l-3-3-3 3v2H3v14h18V11h-6Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            